export default "__VITE_ASSET__Cie$Kb5W__"